import axios from 'axios';

export const updateBrokerColorSchema = (data, brand) =>
  axios.post('/config/setting/ColorSettingClient/', data, { params: { brand } });

export const getBrokerColorSchema = brand => axios.get('/config/setting/ColorSettingClient/', { params: { brand } });

export const getCustomizationBrands = () => axios.get('/config/resource/BrandResource/resource/');
